import { Button, ColorPicker, Descriptions, Flex, Switch, Tooltip  } from "antd";
import React, { useEffect, useState } from "react";
import { InfoCircleOutlined } from '@ant-design/icons';

function AppTheme({ data, baseData, onUpdate }) {
  const [logoOption, setLogoOption] = useState(baseData?.use_custom ? "custom" : "default");

  const handleLogoChange = (e) => {
    setLogoOption(e);
  };

  const [colorData, setColorData] = useState([]);

  useEffect(() => {
    setColorData(data);
    setLogoOption(baseData?.use_custom ? "custom" : "default")
  }, [data, baseData]);

  const handleColorChange = (index, color) => {
    const rgb = color.metaColor;

    // Convert RGB to pure hex (without alpha)
    const toHex = (c) => {
      const hex = c.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };

    const hexColor = `#${toHex(rgb.r)}${toHex(rgb.g)}${toHex(rgb.b)}`;
    const opacity = Math.round(rgb.a * 100); // a is 0-1

    setColorData((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              custom_value: hexColor,
              custom_opacity: opacity,
            }
          : item
      )
    );

    console.log("Updated Color Data:", {
      hex: hexColor,
      opacity,
    });
  };

  const handleSave = () => {
    let payload = {
      id: baseData?.id,
      use_custom: logoOption === "custom" ? true : false,
      value_json: colorData,
    };

    onUpdate(payload);
  };

  return (
    <div>
      <Descriptions column={2} bordered>
        <Descriptions.Item label={<strong>Default</strong>} />
        <Descriptions.Item label={<strong>Custom</strong>} />

        {colorData.map((item, index) => (
          <>
            <Descriptions.Item  label={
                <span>
                  {item?.name}{' '}
                  {item?.description && (
                    <Tooltip title={item.description}>
                      <InfoCircleOutlined style={{ fontSize: '0.75em', cursor: 'pointer', verticalAlign: 'super', marginLeft: 4, color: '#999' }} />
                    </Tooltip>
                  )}
                </span>
              }>
              <ColorPicker
                defaultValue={item.default_value}
                value={item.default_value}
                disabled
                showText
              />
            </Descriptions.Item>

            <Descriptions.Item label={<span>
                  {item?.name}{' '}
                  {item?.description && (
                    <Tooltip title={item.description} >
                      <InfoCircleOutlined style={{ fontSize: '0.75em', cursor: 'pointer', verticalAlign: 'super', marginLeft: 4, color: '#999' }} />
                    </Tooltip>
                  )}
                </span>}>
              <ColorPicker
                defaultValue={item.custom_value}
                onChange={(color) => handleColorChange(index, color)}
                showText
                allowClear={false}
              />
            </Descriptions.Item>
          </>
        ))}

        <Descriptions.Item label="Use Custom">
          <Switch
            checked={logoOption === "custom"}
            onChange={(checked) =>
              handleLogoChange(checked ? "custom" : "default")
            }
            checkedChildren="Custom"
            unCheckedChildren="Default"
          />
        </Descriptions.Item>
      </Descriptions>

      <Flex className="mt-5" justify="flex-end">
        <Button type="primary" onClick={handleSave}>Save</Button>
      </Flex>
    </div>
  );
}

export default AppTheme;
